import {bindable, customElement} from "aurelia-framework";

@customElement('brygg-container')
export class BryggContainer {
  @bindable() minWidth;
}
